export default "__VITE_ASSET__DAsQHQX6__"